import { duration } from "moment";
import { currentDate } from "utils/constants";

type ObjectTypeWithAnyValue = {
  [key: string]: any;
};

type LeadStateTypes = {
  loading: boolean;
  error: string | null;
  leads: {
    [key: string]: [];
  };
  meta: { [key: string]: any };
};

type AdminLeadStateTypes = {
  loading: boolean;
  error: string | null;
  leads: [];
  meta: { [key: string]: any };
};

type projectDocumentStateTypes = {
  loading: boolean;
  error: string | null;
  projectDocuments: [];
  meta: { [key: string]: any };
};

type AdminPropertyStateTypes = {
  loading: boolean;
  error: string | null;
  properties: [];
  "individual-properties": [];
  meta: { [key: string]: any };
};

type TaskStateTypes = {
  loading: boolean;
  error: string | null;
  tasks: [];
  dashboardTasks: [];
  meta: { [key: string]: any };
};

type ContactStateTypes = {
  loading: boolean;
  error: string | null;
  contacts: [];
  meta: { [key: string]: any };
};

type BlockStateTypes = {
  loading: boolean;
  error: string | null;
  blocks: [];
  meta: { [key: string]: any };
};

type PhaseStateTypes = {
  loading: boolean;
  error: string | null;
  phases: [];
  meta: { [key: string]: any };
};

type TokenStateTypes = {
  loading: boolean;
  error: string | null;
  tokens: [];
  meta: { [key: string]: any };
};

type InventoryStateTypes = {
  loading: boolean;
  error: string | null;
  inventory: [];
  meta: { [key: string]: any };
};

type TeamStateTypes = {
  loading: boolean;
  error: string | null;
  teams: [];
  meta: { [key: string]: any };
};

type ProjectAssignmentStateTypes = {
  loading: boolean;
  error: string | null;
  projectAssignments: [];
  userProjectAssignments: [];
  teamProjectAssignments: [];
  projectAssignmentId: string | null;
  meta: { [key: string]: any };
};

type StaffTargetStateTypes = {
  loading: boolean;
  error: string | null;
  staffTargets: [];
  staffTargetsDashboard: [];
  meta: { [key: string]: any };
};

type CompanyStateTypes = {
  loading: boolean;
  error: string | null;
  company: { [key: string]: any };
  license: { [key: string]: any };
  meta: { [key: string]: any };
};

type CommentStateTypes = {
  loading: boolean;
  error: string | null;
  comments: [];
  tokenComments: [];
  meta: { [key: string]: any };
};

type DropdownDataStateTypes = {
  loading: boolean;
  error: string | null;
  data: {
    projects: {
      meta: { [key: string]: any };
      objects: [];
    };
    leads: {
      meta: { [key: string]: any };
      objects: [];
    };
    source: {
      meta: { [key: string]: any };
      objects: [];
    };
    user: {
      meta: { [key: string]: any };
      objects: [];
    };
    "all-users": {
      meta: { [key: string]: any };
      objects: [];
    };
    property: {
      meta: { [key: string]: any };
      objects: [];
    };
    "individual-property": {
      meta: { [key: string]: any };
      objects: [];
    };
  };
};

type LeadActiviesStateTypes = {
  loading: boolean;
  error: string | null;
  leadActivities: [];
  tokenActivities: [];
  propertyActivities: [];
  individualPropertyActivities: [];
  staffTarget: [];
  taskActivities: [];
  teamActivities: [];
  meta: { [key: string]: any };
};

type LeadTasksStateTypes = {
  loading: boolean;
  error: string | null;
  leadTasks: [];
  meta: { [key: string]: any };
};

type LoginUserStateTypes = {
  loading: boolean;
  error: string | null;
  userDetail: {
    [key: string]: any;
  } | null;
  isAuthenticated: boolean;
  isAdmin: boolean;
  isManager: boolean;
  userProfile: {
    [key: string]: any;
  } | null;
  profileLoading: boolean;
};

type TableStateSliceStateTypes = {
  loading: boolean;
  error: string | null;
  tableStates: {
    "raw-lead": { [key: string]: any };
    "polished-lead": { [key: string]: any };
    "admin-lead": { [key: string]: any };
    task: { [key: string]: any };
    "call-record": { [key: string]: any };
    "property-unit": { [key: string]: any };
    "individual-property-unit": { [key: string]: any };
    token: { [key: string]: any };
    "staff-target": { [key: string]: any };
    sales: { [key: string]: any };
  };
};

type callRecordStateTypes = {
  loading: boolean;
  error: string | null;
  callRecord: [];
  meta: { [key: string]: any };
};

type allActivitiesStateTypes = {
  loading: boolean;
  error: string | null;
  activities: [];
  meta: { [key: string]: any };
};

type customerDataStateTypes = {
  loading: boolean;
  error: string | null;
  customerData: { [key: string]: any };
};

type ProjectStateTypes = {
  loading: boolean;
  error: string | null;
  projects: [];
  meta: { [key: string]: any };
};

type SalesStateTypes = {
  loading: boolean;
  error: string | null;
  sales: [];
  meta: { [key: string]: any };
};

type SourceStateTypes = {
  loading: boolean;
  error: string | null;
  source: [];
  meta: { [key: string]: any };
};

type UsersStateTypes = {
  loading: boolean;
  error: string | null;
  users: [];
  userDetail: null | { [key: string]: any };
  meta: { [key: string]: any };
  userProfile: {
    [key: string]: any;
  } | null;
  profileLoading: boolean;
};

type DashboardTaskStatsStateTypes = {
  loading: boolean;
  error: string | null;
  taskStats: { [key: string]: any };
  meta: { [key: string]: any };
};

type DashboardLeadStatsStateTypes = {
  loading: boolean;
  error: string | null;
  leadStats: { [key: string]: any };
  meta: { [key: string]: any };
};

type UserDashboardStateStateTypes = {
  loading: boolean;
  error: string | null;
  userDashboardState: { [key: string]: any };
  meta: { [key: string]: any };
};

type UserPrimaryDashboardStateStateTypes = {
  loading: boolean;
  error: string | null;
  userPrimaryDashboard: { [key: string]: any };
  meta: { [key: string]: any };
};

type DashboardWidgetStateTypes = {
  loading: boolean;
  error: string | null;
  widgetsArray: any[];
  meta: { [key: string]: any };
};

type DashboardCardsStateTypes = {
  loading: boolean;
  error: string | null;
  cardsArray: any[];
  meta: { [key: string]: any };
};

type UserPermissionStateTypes = {
  loading: boolean;
  error: string | null;
  permissions: any[];
  detailPagePermissions: any[];
};

export const initialPermissionState: UserPermissionStateTypes = {
  loading: false,
  error: null,
  permissions: [],
  detailPagePermissions: [],
};

type UserSettingStateTypes = {
  loading: boolean;
  error: string | null;
  settings: any[];
  isDarkMode: boolean;
};

export const initialSettingState: UserSettingStateTypes = {
  loading: false,
  error: null,
  settings: [],
  isDarkMode: false,
};

export const defaultMetaObj: ObjectTypeWithAnyValue = {
  limit: 20,
  next: null,
  previous: null,
  total_count: 0,
  offset: 0,
};

export const dashboardCardState: ObjectTypeWithAnyValue = {
  data: [],
  leadsData: {
    data: [],
    loading: false,
    error: null,
    total_count: 0,
  },
  inventoryData: {
    data: [],
    loading: false,
    error: null,
    total_count: 0,
  },
  loading: false,
  error: null,
  total_count: 0,
};

export const initialLeadState: LeadStateTypes = {
  loading: false,
  error: null,
  leads: {
    "raw-lead": [],
    "polished-lead": [],
    common: [],
  },
  meta: defaultMetaObj,
};

export const initialTaskState: TaskStateTypes = {
  loading: false,
  error: null,
  tasks: [],
  dashboardTasks: [],
  meta: defaultMetaObj,
};

export const initialContactState: ContactStateTypes = {
  loading: false,
  error: null,
  contacts: [],
  meta: defaultMetaObj,
};

export const initialProjectBlockState: BlockStateTypes = {
  loading: false,
  error: null,
  blocks: [],
  meta: defaultMetaObj,
};

export const initialProjectPhaseState: PhaseStateTypes = {
  loading: false,
  error: null,
  phases: [],
  meta: defaultMetaObj,
};

export const initialTokenState: TokenStateTypes = {
  loading: false,
  error: null,
  tokens: [],
  meta: defaultMetaObj,
};

export const initialInventoryState: InventoryStateTypes = {
  loading: false,
  error: null,
  inventory: [],
  meta: defaultMetaObj,
};

export const initialTeamState: TeamStateTypes = {
  loading: false,
  error: null,
  teams: [],
  meta: defaultMetaObj,
};

export const initialProjectAssignmentState: ProjectAssignmentStateTypes = {
  loading: false,
  error: null,
  projectAssignments: [],
  userProjectAssignments: [],
  teamProjectAssignments: [],
  projectAssignmentId: null,
  meta: defaultMetaObj,
};

export const initialStaffTargetState: StaffTargetStateTypes = {
  loading: false,
  error: null,
  staffTargets: [],
  staffTargetsDashboard: [],
  meta: defaultMetaObj,
};

export const initialCompanyState: CompanyStateTypes = {
  loading: false,
  error: null,
  company: {},
  license: {},
  meta: defaultMetaObj,
};

export const initialCommentState: CommentStateTypes = {
  loading: false,
  error: null,
  comments: [],
  tokenComments: [],
  meta: defaultMetaObj,
};

export const initialDropdownDataState: DropdownDataStateTypes = {
  loading: false,
  error: null,
  data: {
    projects: {
      meta: defaultMetaObj,
      objects: [],
    },
    leads: {
      meta: defaultMetaObj,
      objects: [],
    },
    source: {
      meta: defaultMetaObj,
      objects: [],
    },
    user: {
      meta: defaultMetaObj,
      objects: [],
    },
    "all-users": {
      meta: defaultMetaObj,
      objects: [],
    },
    property: {
      meta: defaultMetaObj,
      objects: [],
    },

    "individual-property": {
      meta: defaultMetaObj,
      objects: [],
    },
  },
};

export const initialLeadActivityState: LeadActiviesStateTypes = {
  loading: false,
  error: null,
  leadActivities: [],
  tokenActivities: [],
  propertyActivities: [],
  individualPropertyActivities: [],
  staffTarget: [],
  taskActivities: [],
  teamActivities: [],
  meta: defaultMetaObj,
};

export const initialLeadTaskState: LeadTasksStateTypes = {
  loading: false,
  error: null,
  leadTasks: [],
  meta: defaultMetaObj,
};

export const initialLoginUserState: LoginUserStateTypes = {
  loading: false,
  error: null,
  userDetail: null,
  isAuthenticated: false,
  isAdmin: false,
  isManager: false,
  userProfile: null,
  profileLoading: false,
};

export const initialTableState: TableStateSliceStateTypes = {
  loading: false,
  error: null,
  tableStates: {
    "raw-lead": {
      tableId: null,
      state: [],
    },
    "polished-lead": {
      tableId: null,
      state: [],
    },
    "admin-lead": {
      tableId: null,
      state: [],
    },
    task: {
      tableId: null,
      state: [],
    },
    "call-record": {
      tableId: null,
      state: [],
    },
    "property-unit": {
      tableId: null,
      state: [],
    },
    "individual-property-unit": {
      tableId: null,
      state: [],
    },
    token: {
      tableId: null,
      state: [],
    },
    "staff-target": {
      tableId: null,
      state: [],
    },

    sales: {
      tableId: null,
      state: [],
    },
  },
};

export const initialCallRecordState: callRecordStateTypes = {
  loading: false,
  error: null,
  callRecord: [],
  meta: { ...defaultMetaObj, limit: 10 },
};

export const initialAllActivitiesState: allActivitiesStateTypes = {
  loading: false,
  error: null,
  activities: [],
  meta: { ...defaultMetaObj, limit: 10 },
};

export const columnsHeader: { [key: string]: string } = {
  phone_number: "Lead",
  customer: "Customer",
  project_name: "Project",
  lead_status: "Lead Status",
  date_created: "Created Date",
  due_date: "Due Date",
  assigned_user: "Assignee",
  agent: "Agent",
  createdby_user: "Created By",
  updatedby_user: "Updated By",
  date_closed: "Closed Date",
  date_updated: "Updated Date",
  action: "Action",
  source: "Source",
  shared_user: "Shared With",
  lead_priority: "Lead Priority",
  task: "Task",
  lead: "Lead",
  task_status: "Task Status",
  task_priority: "Task Priority",
  call_type: "Call Type",
  call_source: "Call Source",
  duration: "Duration (sec)",
  recording: "Recording",
  project: "Project",
  timestamp: "Timestamp",
  select: "Select",
  task_count: "Task Count",
  base_rate: "Base Rate",
  block_number: "Block No",
  block_no: "Block No",
  depth: "Depth (Feet)",
  front: "Front (Feet)",
  corner_plot: "Corner Plot",
  facing_park: "Facing Park",
  property_dimension: "Property Dimension",
  property_id: "ID",
  property_listing: "Property Listing",
  property_nature: "Property Nature",
  property_number: "Property No",
  property_size: "Property Size",
  property_status: "Property Status",
  property_type: "Property Type",
  sales_rate: "Sales Rate (PKR)",
  sales_price: "Sales Price (PKR)",
  size_in_marla: "Size (Marla)",
  size_in_square_feet: "Size (Sq.feet)",
  total_area: "Total Area",
  unit_of_measurement: "Unit",
  agreed_price: "Agreed Price (PKR)",
  date_expiry: "Expiry Date",
  expected_bayana: "Expected Bayana (PKR)",
  installment_rate: "Installment Rate (PKR)",
  payment_plan: "Payment Plan",
  property_unit: "Property",
  rate_per_marla: "Rate Per Marla (PKR)",
  receipt_id: "Token No.",
  token: "Token",
  token_id: "ID",
  token_amount: "Token Amount (PKR)",
  token_status: "Token Status",
  constructed_area: "Constructed Area(Sq.feet)",
  progress: "Progress",
  target_set: "Target Set",
  target_type: "Target Type",
  city: "City",
  corner_property: "Corner Property",
  facing_road: "Facing Road",
  west_open: "West Open",
  property_no: "Property No",
  token_booked: "Token Booked",
  agreed_rate: "Agreed Rate",
  manual_receipt_no: "Manual Receipt No",
  token_no: "Token No",
  size: "Size",
  description: "Description",
  status: "Status",
  phase: "Phase",
  token_expiry: "Token Expiry",
  qualified_call: "Qualified Calls",
  date: "Date",
  sale_amount: "Sale Amount",
  sale_id: "Sale Id",
  customer_visited: "Customer Visited",
};

export const rawLeadColumnsOrder: { [key: string]: number } = {
  phone_number: 1,
  customer: 2,
  project_name: 3,
  lead_status: 4,
  lead_priority: 5,
  source: 6,
  date_created: 7,
  due_date: 8,
  assigned_user: 9,
  createdby_user: 10,
  updatedby_user: 11,
  date_closed: 12,
  date_updated: 13,
  shared_user: 14,
  task_count: 15,
  action: 16,
};

export const polishedLeadColumnsOrder: { [key: string]: number } = {
  phone_number: 1,
  customer: 2,
  project_name: 3,
  lead_status: 4,
  lead_priority: 5,
  source: 6,
  date_created: 7,
  due_date: 8,
  assigned_user: 9,
  createdby_user: 10,
  updatedby_user: 11,
  date_closed: 12,
  date_updated: 13,
  shared_user: 14,
  task_count: 15,
  action: 16,
};

export const taskColumnsOrder: { [key: string]: number } = {
  task: 1,
  lead: 2,
  customer: 3,
  task_status: 4,
  task_priority: 5,
  date_created: 6,
  due_date: 7,
  assigned_user: 8,
  createdby_user: 9,
  date_closed: 10,
  action: 11,
};

export const callRecordColumnsOrder: {
  [key: string]: number;
} = {
  timestamp: 1,
  agent: 2,
  lead: 3,
  project: 4,
  customer: 5,
  call_source: 6,
  call_type: 7,
  duration: 8,
  recording: 9,
  action: 10,
};

// will update after adding endpoint
export const adminLeadColumnsOrder: { [key: string]: number } = {
  select: 1,
  phone_number: 2,
  customer: 3,
  project_name: 4,
  lead_status: 5,
  lead_priority: 6,
  source: 7,
  date_created: 8,
  due_date: 9,
  assigned_user: 10,
  createdby_user: 11,
  date_closed: 12,
  shared_user: 13,
};

export const propertyUnitColumnsOrder: { [key: string]: number } = {
  property_no: 1,
  block_no: 2,
  phase: 3,
  project: 4,
  property_listing: 5,
  property_status: 6,
  property_type: 7,
  size: 8,
  property_nature: 9,
  sales_rate: 10,
  sales_price: 10,
  corner_plot: 11,
  facing_park: 12,
  date_created: 13,
  createdby_user: 14,
};

export const individualPropertyUnitColumnsOrder: { [key: string]: number } = {
  property_no: 1,
  property_listing: 2,
  property_status: 3,
  property_type: 4,
  size: 5,
  property_nature: 6,
  city: 7,
  sales_rate: 8,
  sales_price: 9,
  corner_plot: 10,
  facing_park: 11,
  facing_road: 12,
  west_open: 13,
  date_created: 14,
  createdby_user: 15,
};

export const tokenColumnsOrder: { [key: string]: number } = {
  token_no: 1,
  manual_receipt_no: 2,
  token_status: 3,
  project: 4,
  property_unit: 5,
  lead: 6,
  customer: 7,
};

export const staffTargetColumnsOrder: { [key: string]: number } = {
  description: 1,
  status: 2,
  target_set: 3,
  target_type: 4,
  progress: 5,
  project: 6,
};

export const salesColumnsOrder: { [key: string]: number } = {
  sale_id: 1,
  customer: 2,
  sale_amount: 3,
  payment_plan: 4,
  property_no: 5,
  property_nature: 6,
  project: 7,
  date: 8,
  agent: 9,
  token: 10,
  lead: 11,
};

export const keysToExcludeFromLeadTableState: string[] = [
  "user",
  "id",
  "resource_uri",
];

export const admin: string = "ADMIN";
export const objectKeys: { [key: string]: string } = {
  user: "user",
};

export const initialCustomerDataState: customerDataStateTypes = {
  loading: false,
  error: null,
  customerData: {},
};

export const initialProjectState: ProjectStateTypes = {
  loading: false,
  error: null,
  projects: [],
  meta: defaultMetaObj,
};

export const initialSalesState: SalesStateTypes = {
  loading: false,
  error: null,
  sales: [],
  meta: defaultMetaObj,
};

export const initialSourceState: SourceStateTypes = {
  loading: false,
  error: null,
  source: [],
  meta: defaultMetaObj,
};

export const initialUserState: UsersStateTypes = {
  loading: false,
  error: null,
  users: [],
  userDetail: null,
  meta: defaultMetaObj,
  userProfile: null,
  profileLoading: false,
};

export const initialAdminLeadState: AdminLeadStateTypes = {
  loading: false,
  error: null,
  leads: [],
  meta: defaultMetaObj,
};

export const initialProjectDocumentState: projectDocumentStateTypes = {
  loading: false,
  error: null,
  projectDocuments: [],
  meta: defaultMetaObj,
};

export const initialAdminProperyState: AdminPropertyStateTypes = {
  loading: false,
  error: null,
  properties: [],
  "individual-properties": [],
  meta: defaultMetaObj,
};

export const initialDashboardTaskStatsState: DashboardTaskStatsStateTypes = {
  loading: false,
  error: null,
  taskStats: {},
  meta: defaultMetaObj,
};

export const initialDashboardLeadStatsState: DashboardLeadStatsStateTypes = {
  loading: false,
  error: null,
  leadStats: {},
  meta: defaultMetaObj,
};

export const initialUserDashboardStateState: UserDashboardStateStateTypes = {
  loading: false,
  error: null,
  userDashboardState: {},
  meta: defaultMetaObj,
};

export const initialUserPrimaryDashboardStateState: UserPrimaryDashboardStateStateTypes =
  {
    loading: false,
    error: null,
    userPrimaryDashboard: {},
    meta: defaultMetaObj,
  };

export const initialDashboardWidgetState: DashboardWidgetStateTypes = {
  loading: false,
  error: null,
  widgetsArray: [],
  meta: defaultMetaObj,
};

export const initialDashboardCardsState: DashboardCardsStateTypes = {
  loading: false,
  error: null,
  cardsArray: [],
  meta: defaultMetaObj,
};

export const isPolishLead: string = "is_polish_lead";

export const deleteErrorResponse: string =
  "Cannot delete some instances of model";

export const deleteErrorResponsePhase =
  "Cannot delete some instances of model 'Project' because they are referenced through protected foreign keys: 'Phase.project'";

export const propertyDeleteErrorModified =
  "This property unit cannot be deleted because it is linked to a token. Please remove that token first.";

export const projectDeleteErrorModified =
  "This project cannot be deleted because it is linked to the following: TaskTarget, Lead, Token, Phase. Please remove these links first.";

export const projectDeleteErrorModifiedPhase =
  "Cannot delete this project because it contains phases. Please delete all phases first.";

export const phaseDeleteErrorModified =
  "This phase cannot be deleted because it is linked to one or more blocks. Please remove these links first.";

export const blockDeleteErrorModified =
  "This block can not be deleted because it is linked to one or more properties. Please remove these links first.";

export const leadDeleteErrorModified =
  "Lead can not be deleted because it is linked to a Token. Please delete token first.";

export const tokenDeleteErrorModified =
  "Token can not be deleted because it is linked to other data. Please remove related record first.";

export const staffTargetCompletedTodayParams: ObjectTypeWithAnyValue = {
  status: "Completed",
  date_closed: currentDate,
};

export const staffTargetInProgressParams: ObjectTypeWithAnyValue = {
  status: "In Progress",
};

export const staffTargetNotStartedCurrentPendingParams: ObjectTypeWithAnyValue =
  {
    status: "Not Started",
    due_date__lte: currentDate,
  };
